import types from '../mutation-types';
import PermutasAPI from '../../api/permutas';
import { throwErrorMessage } from '../utils/api';

export const state = {
  acervo: [],
  leads: [],
  generatedAt: null,
  uiFlags: { isFetching: false },
};

export const getters = {
  getAcervo: $s => $s.acervo,
  getLeads: $s => $s.leads,
  getGeneratedAt: $s => $s.generatedAt,
  getUIFlags: $s => $s.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_PERMUTAS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await PermutasAPI.get();
      commit(types.SET_PERMUTAS, data);
    } catch (e) {
      /* silent — API may be unavailable or feature not enabled */
    } finally {
      commit(types.SET_PERMUTAS_UI_FLAG, { isFetching: false });
    }
  },
  createManual: async ({ dispatch }, payload) => {
    try {
      await PermutasAPI.create(payload);
      await dispatch('get');
    } catch (e) {
      throwErrorMessage(e);
    }
  },
  updateStatus: async ({ dispatch }, { source, code, status }) => {
    try {
      await PermutasAPI.setStatus({ source, code, status });
      await dispatch('get');
    } catch (e) {
      throwErrorMessage(e);
    }
  },
  // Abre (ou cria) o contato do dono e devolve a conversa no Chatwoot.
  // Retorna { conversation_id, contact_id } pro componente navegar.
  openConversation: async (_ctx, payload) => {
    const { data } = await PermutasAPI.openConversation(payload);
    return data;
  },
  // Puxa as infos de um imóvel pelo código (cadastro "do site").
  lookup: async (_ctx, code) => {
    const { data } = await PermutasAPI.lookup(code);
    return data;
  },
  // Busca contatos (nome/telefone/email) pra vincular o proprietário.
  searchContacts: async (_ctx, q) => {
    const { data } = await PermutasAPI.searchContacts(q);
    return data;
  },
  remove: async ({ dispatch }, id) => {
    try {
      await PermutasAPI.delete(id);
      await dispatch('get');
    } catch (e) {
      throwErrorMessage(e);
    }
  },
};

export const mutations = {
  [types.SET_PERMUTAS]($s, data) {
    $s.acervo = data.acervo || [];
    $s.leads = data.leads || [];
    $s.generatedAt = data.generated_at;
  },
  [types.SET_PERMUTAS_UI_FLAG]($s, flag) {
    $s.uiFlags = { ...$s.uiFlags, ...flag };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
